import React from 'react';

function Header() {
    return (
        <header className="header">
            <a href="#home" className="logo" aria-label="RDK Home">
                RDK<span>.dev</span>
            </a>
            
            <nav className="navbar" role="navigation" aria-label="Main navigation">
                <a href="#home" className="active">Home</a>
                <a href="#about">About</a>
                <a href="#services">Skills</a>
                <a href="#portfolio">Projects</a>
                <a href="#contact">Contact</a>
            </nav>
            
            {/* Icons container - keeps them side by side on mobile */}
            <div className="header-icons">
                <div 
                    className="bx bxs-moon" 
                    id="darkMode-icon" 
                    role="button" 
                    tabIndex={0} 
                    aria-label="Toggle dark mode"
                ></div>
                <div 
                    className="bx bx-menu-alt-right" 
                    id="menu-icon" 
                    role="button" 
                    tabIndex={0} 
                    aria-label="Toggle menu"
                ></div>
            </div>
        </header>
    );
}

export default Header;